
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as createqzj9pybOVbMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/create.vue?macro=true";
import { default as _91id_93lQHgVQ9BozMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/edit/[id].vue?macro=true";
import { default as indexZvuEB2dwfJMeta } from "/var/www/frontend_build/.app/pages/admin/announcements/index.vue?macro=true";
import { default as createjPw7kRZC2PMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/create.vue?macro=true";
import { default as _91id_93qTA4k22CIpMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/edit/[id].vue?macro=true";
import { default as indexkBsIJxOsbzMeta } from "/var/www/frontend_build/.app/pages/admin/blocked/links/index.vue?macro=true";
import { default as createDvmBb45ScqMeta } from "/var/www/frontend_build/.app/pages/admin/constants/create.vue?macro=true";
import { default as _91id_93BZCSW5AdzEMeta } from "/var/www/frontend_build/.app/pages/admin/constants/edit/[id].vue?macro=true";
import { default as indexLXWbjPFMp5Meta } from "/var/www/frontend_build/.app/pages/admin/constants/index.vue?macro=true";
import { default as createTlitYD1HUoMeta } from "/var/www/frontend_build/.app/pages/admin/contracts/create.vue?macro=true";
import { default as _91id_93N3AFbz0nFtMeta } from "/var/www/frontend_build/.app/pages/admin/contracts/edit/[id].vue?macro=true";
import { default as index1utP02TJD8Meta } from "/var/www/frontend_build/.app/pages/admin/contracts/index.vue?macro=true";
import { default as createNnIOf25AxLMeta } from "/var/www/frontend_build/.app/pages/admin/faqs/create.vue?macro=true";
import { default as _91id_93EZay2EU2H4Meta } from "/var/www/frontend_build/.app/pages/admin/faqs/edit/[id].vue?macro=true";
import { default as index5cfjLiXShwMeta } from "/var/www/frontend_build/.app/pages/admin/faqs/index.vue?macro=true";
import { default as createqQH7K9kcPbMeta } from "/var/www/frontend_build/.app/pages/admin/pages/create.vue?macro=true";
import { default as _91id_93X6KsYHeO0rMeta } from "/var/www/frontend_build/.app/pages/admin/pages/edit/[id].vue?macro=true";
import { default as index8Wx9pOgnYVMeta } from "/var/www/frontend_build/.app/pages/admin/pages/index.vue?macro=true";
import { default as createSpugr0W0dpMeta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/create.vue?macro=true";
import { default as _91id_93pR4LC8L6I0Meta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/edit/[id].vue?macro=true";
import { default as indexCSgBQyzYboMeta } from "/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/index.vue?macro=true";
import { default as createTrRgVzV2KRMeta } from "/var/www/frontend_build/.app/pages/admin/parameters/create.vue?macro=true";
import { default as _91id_93OzQtrsuUGKMeta } from "/var/www/frontend_build/.app/pages/admin/parameters/edit/[id].vue?macro=true";
import { default as indexDqn28lsZOUMeta } from "/var/www/frontend_build/.app/pages/admin/parameters/index.vue?macro=true";
import { default as indexelUgyA08WqMeta } from "/var/www/frontend_build/.app/pages/admin/registration/index.vue?macro=true";
import { default as createJQIth1Oq1ZMeta } from "/var/www/frontend_build/.app/pages/admin/roles/create.vue?macro=true";
import { default as _91id_93C8fJoM0FhPMeta } from "/var/www/frontend_build/.app/pages/admin/roles/edit/[id].vue?macro=true";
import { default as indexPCj5yGuTZuMeta } from "/var/www/frontend_build/.app/pages/admin/roles/index.vue?macro=true";
import { default as indexjuINY5SlVLMeta } from "/var/www/frontend_build/.app/pages/admin/roles/permissions/[id]/index.vue?macro=true";
import { default as createhwlmCnwkWEMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/create.vue?macro=true";
import { default as _91id_93gt82kBzOydMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/edit/[id].vue?macro=true";
import { default as indexIQknFwuNtOMeta } from "/var/www/frontend_build/.app/pages/admin/service/categories/index.vue?macro=true";
import { default as createeteePaf6iBMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/create.vue?macro=true";
import { default as _91rule_id_934flXwgu7pdMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/edit/[rule_id].vue?macro=true";
import { default as indexmI0ZtJo9BpMeta } from "/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/index.vue?macro=true";
import { default as settingsqrbjAN3RcwMeta } from "/var/www/frontend_build/.app/pages/admin/settings.vue?macro=true";
import { default as indexHrKchfEHuEMeta } from "/var/www/frontend_build/.app/pages/balance/packages/index.vue?macro=true";
import { default as indexM9aLch4MeTMeta } from "/var/www/frontend_build/.app/pages/contract/gizlilik-ve-cerez-politikasi/index.vue?macro=true";
import { default as indexVDEdQTjFFrMeta } from "/var/www/frontend_build/.app/pages/contract/kvkk/index.vue?macro=true";
import { default as indexdiqTcZDXw0Meta } from "/var/www/frontend_build/.app/pages/dashboard/index.vue?macro=true";
import { default as indexattmg6WcVbMeta } from "/var/www/frontend_build/.app/pages/faq/index.vue?macro=true";
import { default as forgotHAbfhbdBC1Meta } from "/var/www/frontend_build/.app/pages/forgot.vue?macro=true";
import { default as indexor8mKMqNJJMeta } from "/var/www/frontend_build/.app/pages/forgottt/index.vue?macro=true";
import { default as indexgfM2baTbPmMeta } from "/var/www/frontend_build/.app/pages/home/index.vue?macro=true";
import { default as indexI7vlsopydNMeta } from "/var/www/frontend_build/.app/pages/index.vue?macro=true";
import { default as indexHige0MBozYMeta } from "/var/www/frontend_build/.app/pages/information/perfect-price-logs/index.vue?macro=true";
import { default as loginaSqImQc0I0Meta } from "/var/www/frontend_build/.app/pages/login.vue?macro=true";
import { default as indexshRtoMMbfyMeta } from "/var/www/frontend_build/.app/pages/me/missions/action/approved/index.vue?macro=true";
import { default as indexbr41LRa09HMeta } from "/var/www/frontend_build/.app/pages/me/missions/action/rejected/index.vue?macro=true";
import { default as indexw2CYodKJpVMeta } from "/var/www/frontend_build/.app/pages/me/missions/action/waiting/index.vue?macro=true";
import { default as indexmHDBx9kHoYMeta } from "/var/www/frontend_build/.app/pages/me/missions/index.vue?macro=true";
import { default as indexF9zCjULphJMeta } from "/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/[id]/index.vue?macro=true";
import { default as indexgEvOs0xAA2Meta } from "/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/index.vue?macro=true";
import { default as _91id_93uqKjWchIBLMeta } from "/var/www/frontend_build/.app/pages/me/missions/proofs/declined/[id].vue?macro=true";
import { default as indexMvQql2S8eoMeta } from "/var/www/frontend_build/.app/pages/me/missions/proofs/index.vue?macro=true";
import { default as _91id_93tXEFJX3XFGMeta } from "/var/www/frontend_build/.app/pages/me/missions/re-upload-proof/[id].vue?macro=true";
import { default as indexZxtjuZWAb3Meta } from "/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/[id]/index.vue?macro=true";
import { default as indexcYLhtiS9yIMeta } from "/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/index.vue?macro=true";
import { default as _91id_937Saj6uAaCHMeta } from "/var/www/frontend_build/.app/pages/mission/[id].vue?macro=true";
import { default as indexQmdmoBYvARMeta } from "/var/www/frontend_build/.app/pages/missions/[id]/index.vue?macro=true";
import { default as create_45backupdWRtbW5ZBvMeta } from "/var/www/frontend_build/.app/pages/missions/create-backup.vue?macro=true";
import { default as create5OG2ciL0upMeta } from "/var/www/frontend_build/.app/pages/missions/create.vue?macro=true";
import { default as _91id_93cs657lNmJzMeta } from "/var/www/frontend_build/.app/pages/missions/detail/[id].vue?macro=true";
import { default as _91id_93Iq4yVrb7bhMeta } from "/var/www/frontend_build/.app/pages/missions/edit/[id].vue?macro=true";
import { default as indexBaNxbyiOy4Meta } from "/var/www/frontend_build/.app/pages/missions/index.vue?macro=true";
import { default as index8hnkTsgWO2Meta } from "/var/www/frontend_build/.app/pages/missions/past-missions/index.vue?macro=true";
import { default as indexCk5gjxHlbIMeta } from "/var/www/frontend_build/.app/pages/missions/pending-approval/index.vue?macro=true";
import { default as indexNFgjgXtR5PMeta } from "/var/www/frontend_build/.app/pages/missions/proof-decline-request/[id]/index.vue?macro=true";
import { default as indexwHZVYz6vNkMeta } from "/var/www/frontend_build/.app/pages/missions/proof-decline-request/index.vue?macro=true";
import { default as indexKlmD6e7skMMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/[id]/index.vue?macro=true";
import { default as indexOWelM4hS78Meta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/index.vue?macro=true";
import { default as indexRqv4RncvwAMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/[id]/index.vue?macro=true";
import { default as indexEz1xb2fZzvMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/index.vue?macro=true";
import { default as indexoA5KfCIBLaMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-users/[id]/index.vue?macro=true";
import { default as indexEI1RDS07qjMeta } from "/var/www/frontend_build/.app/pages/missions/proof-pending-users/index.vue?macro=true";
import { default as indexnozUuVG4ZcMeta } from "/var/www/frontend_build/.app/pages/missions/proofs/[id]/index.vue?macro=true";
import { default as indexDhC7VRkEUUMeta } from "/var/www/frontend_build/.app/pages/missions/proofs/me/[id]/index.vue?macro=true";
import { default as _91id_93Ew2M6jLnlaMeta } from "/var/www/frontend_build/.app/pages/missions/show/[id].vue?macro=true";
import { default as indexyoW3Mfv3LmMeta } from "/var/www/frontend_build/.app/pages/missions/tracking/me/[id]/index.vue?macro=true";
import { default as indexccuvK1OlG8Meta } from "/var/www/frontend_build/.app/pages/missions/user-with-proofs/[id]/index.vue?macro=true";
import { default as indexK0ihlyogmZMeta } from "/var/www/frontend_build/.app/pages/missions/user-with-proofs/index.vue?macro=true";
import { default as createTeMXhHSek0Meta } from "/var/www/frontend_build/.app/pages/mobile/announcements/create.vue?macro=true";
import { default as _91id_93YvsTLrWilrMeta } from "/var/www/frontend_build/.app/pages/mobile/announcements/edit/[id].vue?macro=true";
import { default as index7zFw2SERevMeta } from "/var/www/frontend_build/.app/pages/mobile/announcements/index.vue?macro=true";
import { default as createQzNq6LNfZIMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/create.vue?macro=true";
import { default as _91id_93yU0dgw8KQtMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/edit/[id].vue?macro=true";
import { default as indexYIjDkpf0fuMeta } from "/var/www/frontend_build/.app/pages/mobile/pages/index.vue?macro=true";
import { default as new_45mission6VNvpxQhOuMeta } from "/var/www/frontend_build/.app/pages/new-mission.vue?macro=true";
import { default as new_45subscriptionWDfmyGH7viMeta } from "/var/www/frontend_build/.app/pages/new-subscription.vue?macro=true";
import { default as indexPIIremzzQ0Meta } from "/var/www/frontend_build/.app/pages/order-tracking/index.vue?macro=true";
import { default as createMcPQOyKj6HMeta } from "/var/www/frontend_build/.app/pages/packages/create.vue?macro=true";
import { default as _91id_93j5RBwZY04dMeta } from "/var/www/frontend_build/.app/pages/packages/edit/[id].vue?macro=true";
import { default as indexl6mG9S3TjYMeta } from "/var/www/frontend_build/.app/pages/packages/index.vue?macro=true";
import { default as indexnoKX34oFqyMeta } from "/var/www/frontend_build/.app/pages/pages/[id]/index.vue?macro=true";
import { default as createwx2BYc1g1EMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/create.vue?macro=true";
import { default as _91id_93uz6wrrk5zMMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/edit/[id].vue?macro=true";
import { default as indexc2qREoliYYMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/index.vue?macro=true";
import { default as createyuNuKX2ugAMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/create.vue?macro=true";
import { default as _91id_93DOclsikipaMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/edit/[id].vue?macro=true";
import { default as index5tOaED1wjwMeta } from "/var/www/frontend_build/.app/pages/payment/accounts/me/index.vue?macro=true";
import { default as createVkvfjWajcVMeta } from "/var/www/frontend_build/.app/pages/payment/plans/create.vue?macro=true";
import { default as _91id_93xTQs46gZr1Meta } from "/var/www/frontend_build/.app/pages/payment/plans/edit/[id].vue?macro=true";
import { default as indexogt2rDT6w8Meta } from "/var/www/frontend_build/.app/pages/payment/plans/index.vue?macro=true";
import { default as indexcACZGyjKN5Meta } from "/var/www/frontend_build/.app/pages/payment/plans/me/index.vue?macro=true";
import { default as _91id_93wi0dBVm8uUMeta } from "/var/www/frontend_build/.app/pages/perfect-service/edit/[id].vue?macro=true";
import { default as indexEubYmAXaprMeta } from "/var/www/frontend_build/.app/pages/perfect-service/index.vue?macro=true";
import { default as _91id_93B2BSYgYUm3Meta } from "/var/www/frontend_build/.app/pages/perfect-service/show/[id].vue?macro=true";
import { default as permission_45denied9pRl42EeAOMeta } from "/var/www/frontend_build/.app/pages/permission-denied.vue?macro=true";
import { default as indexv1R7MCbCSAMeta } from "/var/www/frontend_build/.app/pages/price/list/index.vue?macro=true";
import { default as index7m7Ze5cbbCMeta } from "/var/www/frontend_build/.app/pages/profile/index.vue?macro=true";
import { default as indexZz1bUXe7uXMeta } from "/var/www/frontend_build/.app/pages/reference-system/index.vue?macro=true";
import { default as createiYvoekFi4oMeta } from "/var/www/frontend_build/.app/pages/references/create.vue?macro=true";
import { default as _91id_93dY1QiI2UPpMeta } from "/var/www/frontend_build/.app/pages/references/edit/[id].vue?macro=true";
import { default as indexVSGKq8xQFoMeta } from "/var/www/frontend_build/.app/pages/references/index.vue?macro=true";
import { default as registerK5Oi3BOypRMeta } from "/var/www/frontend_build/.app/pages/register.vue?macro=true";
import { default as createGa7ZQwrOcMMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/create.vue?macro=true";
import { default as _91id_93XoXf4YboRrMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/edit/[id].vue?macro=true";
import { default as indexf6tQvFZu4XMeta } from "/var/www/frontend_build/.app/pages/reward-settings/categories/index.vue?macro=true";
import { default as createPqgIwTGHIUMeta } from "/var/www/frontend_build/.app/pages/reward-settings/items/create.vue?macro=true";
import { default as _91id_93DjIZv2MsprMeta } from "/var/www/frontend_build/.app/pages/reward-settings/items/edit/[id].vue?macro=true";
import { default as indexa1zNuHh3x2Meta } from "/var/www/frontend_build/.app/pages/reward-settings/items/index.vue?macro=true";
import { default as create6RHJUrRrhYMeta } from "/var/www/frontend_build/.app/pages/reward/requests/create.vue?macro=true";
import { default as indexldHp69mVyGMeta } from "/var/www/frontend_build/.app/pages/reward/requests/index.vue?macro=true";
import { default as indexEkNXvFNpmDMeta } from "/var/www/frontend_build/.app/pages/reward/requests/me/create/[id]/index.vue?macro=true";
import { default as indexrMkEn0Pk9SMeta } from "/var/www/frontend_build/.app/pages/reward/requests/me/create/index.vue?macro=true";
import { default as indexqBDRCxGeQlMeta } from "/var/www/frontend_build/.app/pages/reward/requests/me/index.vue?macro=true";
import { default as createLthK0gmxITMeta } from "/var/www/frontend_build/.app/pages/service-packages/create.vue?macro=true";
import { default as _91id_93a0WBjAPuGMMeta } from "/var/www/frontend_build/.app/pages/service-packages/edit/[id].vue?macro=true";
import { default as indexfyRUldC79oMeta } from "/var/www/frontend_build/.app/pages/service-packages/index.vue?macro=true";
import { default as create4C6lVQpACQMeta } from "/var/www/frontend_build/.app/pages/services/create.vue?macro=true";
import { default as _91id_93CstVHHPQ0dMeta } from "/var/www/frontend_build/.app/pages/services/edit/[id].vue?macro=true";
import { default as index6rbdrdmbG3Meta } from "/var/www/frontend_build/.app/pages/services/index.vue?macro=true";
import { default as _91id_93y9vsEf7S5bMeta } from "/var/www/frontend_build/.app/pages/services/steps/[id].vue?macro=true";
import { default as createphCY2Zdx29Meta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/create.vue?macro=true";
import { default as _91id_933NltDVEbjPMeta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/edit/[id].vue?macro=true";
import { default as indexMECCssBCEMMeta } from "/var/www/frontend_build/.app/pages/social/accounts/banned/index.vue?macro=true";
import { default as indexeGIuJYbvdnMeta } from "/var/www/frontend_build/.app/pages/social/accounts/index.vue?macro=true";
import { default as indexGmUcmgnS4EMeta } from "/var/www/frontend_build/.app/pages/social/accounts/proof/index.vue?macro=true";
import { default as createOTvB4rYG1TMeta } from "/var/www/frontend_build/.app/pages/store/orders/create.vue?macro=true";
import { default as indexOZFfF7yVL0Meta } from "/var/www/frontend_build/.app/pages/store/orders/index.vue?macro=true";
import { default as indexMeXvUoLO3CMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_group_id]/index.vue?macro=true";
import { default as indexkgTaMIBl7aMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_service_id]/index.vue?macro=true";
import { default as indextd03po33ruMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/index.vue?macro=true";
import { default as indexPE8MiODQefMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/create/index.vue?macro=true";
import { default as index6YTX7SVHnSMeta } from "/var/www/frontend_build/.app/pages/store/orders/me/index.vue?macro=true";
import { default as createrUEYYPEmTwMeta } from "/var/www/frontend_build/.app/pages/store/settings/categories/create.vue?macro=true";
import { default as _91id_93TR1J6Rkp87Meta } from "/var/www/frontend_build/.app/pages/store/settings/categories/edit/[id].vue?macro=true";
import { default as indexmlixZzyS5RMeta } from "/var/www/frontend_build/.app/pages/store/settings/categories/index.vue?macro=true";
import { default as createWjTi6UltsZMeta } from "/var/www/frontend_build/.app/pages/store/settings/groups/create.vue?macro=true";
import { default as _91id_934ycKlXqqqfMeta } from "/var/www/frontend_build/.app/pages/store/settings/groups/edit/[id].vue?macro=true";
import { default as indexiw5wOBg6RAMeta } from "/var/www/frontend_build/.app/pages/store/settings/groups/index.vue?macro=true";
import { default as createUA0xR0MrOXMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/create.vue?macro=true";
import { default as _91id_93ODVQC8LrihMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/edit/[id].vue?macro=true";
import { default as index7B1O6GfR1WMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/index.vue?macro=true";
import { default as createsDPBhHmn4PMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/create.vue?macro=true";
import { default as _91id_93Yv23fHvsCRMeta } from "/var/www/frontend_build/.app/pages/store/settings/packages/edit/[id].vue?macro=true";
import { default as indexaK1jlEjIo0Meta } from "/var/www/frontend_build/.app/pages/store/settings/packages/index.vue?macro=true";
import { default as createBxuTq8vynLMeta } from "/var/www/frontend_build/.app/pages/store/settings/services/create.vue?macro=true";
import { default as _91id_93bnA5nuiivYMeta } from "/var/www/frontend_build/.app/pages/store/settings/services/edit/[id].vue?macro=true";
import { default as indexAogWeW3MgmMeta } from "/var/www/frontend_build/.app/pages/store/settings/services/index.vue?macro=true";
import { default as indexxdRz4NwExxMeta } from "/var/www/frontend_build/.app/pages/subscription-packages/index.vue?macro=true";
import { default as indexgAssRTdMdSMeta } from "/var/www/frontend_build/.app/pages/subscriptions/index.vue?macro=true";
import { default as indexPH96J7Rob5Meta } from "/var/www/frontend_build/.app/pages/subscriptions/pending-approval/index.vue?macro=true";
import { default as _91id_93n24lnNVZhIMeta } from "/var/www/frontend_build/.app/pages/tickets/detail-for-user/[id].vue?macro=true";
import { default as _91id_93AG1L7Gzm4LMeta } from "/var/www/frontend_build/.app/pages/tickets/detail/[id].vue?macro=true";
import { default as _91id_93VrblG9km2fMeta } from "/var/www/frontend_build/.app/pages/tickets/edit/[id].vue?macro=true";
import { default as indexd9LsEmgz0xMeta } from "/var/www/frontend_build/.app/pages/tickets/index.vue?macro=true";
import { default as indexBUegm63sz6Meta } from "/var/www/frontend_build/.app/pages/tickets/me/[id]/index.vue?macro=true";
import { default as createtnmLsqcDk3Meta } from "/var/www/frontend_build/.app/pages/tickets/me/create.vue?macro=true";
import { default as index9y3XYmHo4JMeta } from "/var/www/frontend_build/.app/pages/tickets/me/index.vue?macro=true";
import { default as two_45factorN6JeXy68ivMeta } from "/var/www/frontend_build/.app/pages/two-factor.vue?macro=true";
import { default as indexQWyDnpnLduMeta } from "/var/www/frontend_build/.app/pages/users/banned/index.vue?macro=true";
import { default as createJDvDfxbrQyMeta } from "/var/www/frontend_build/.app/pages/users/create.vue?macro=true";
import { default as _91id_93fSN3NcwUV0Meta } from "/var/www/frontend_build/.app/pages/users/edit/[id].vue?macro=true";
import { default as indexn1RB3cGGSkMeta } from "/var/www/frontend_build/.app/pages/users/index.vue?macro=true";
import { default as verifyKApjB3aXEiMeta } from "/var/www/frontend_build/.app/pages/verify.vue?macro=true";
export default [
  {
    name: "admin-announcements-create",
    path: "/admin/announcements/create",
    meta: createqzj9pybOVbMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/create.vue")
  },
  {
    name: "admin-announcements-edit-id",
    path: "/admin/announcements/edit/:id()",
    meta: _91id_93lQHgVQ9BozMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/edit/[id].vue")
  },
  {
    name: "admin-announcements",
    path: "/admin/announcements",
    meta: indexZvuEB2dwfJMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/announcements/index.vue")
  },
  {
    name: "admin-blocked-links-create",
    path: "/admin/blocked/links/create",
    meta: createjPw7kRZC2PMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/create.vue")
  },
  {
    name: "admin-blocked-links-edit-id",
    path: "/admin/blocked/links/edit/:id()",
    meta: _91id_93qTA4k22CIpMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/edit/[id].vue")
  },
  {
    name: "admin-blocked-links",
    path: "/admin/blocked/links",
    meta: indexkBsIJxOsbzMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/blocked/links/index.vue")
  },
  {
    name: "admin-constants-create",
    path: "/admin/constants/create",
    meta: createDvmBb45ScqMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/create.vue")
  },
  {
    name: "admin-constants-edit-id",
    path: "/admin/constants/edit/:id()",
    meta: _91id_93BZCSW5AdzEMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/edit/[id].vue")
  },
  {
    name: "admin-constants",
    path: "/admin/constants",
    meta: indexLXWbjPFMp5Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/constants/index.vue")
  },
  {
    name: "admin-contracts-create",
    path: "/admin/contracts/create",
    meta: createTlitYD1HUoMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/create.vue")
  },
  {
    name: "admin-contracts-edit-id",
    path: "/admin/contracts/edit/:id()",
    meta: _91id_93N3AFbz0nFtMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/edit/[id].vue")
  },
  {
    name: "admin-contracts",
    path: "/admin/contracts",
    meta: index1utP02TJD8Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/contracts/index.vue")
  },
  {
    name: "admin-faqs-create",
    path: "/admin/faqs/create",
    meta: createNnIOf25AxLMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/create.vue")
  },
  {
    name: "admin-faqs-edit-id",
    path: "/admin/faqs/edit/:id()",
    meta: _91id_93EZay2EU2H4Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/edit/[id].vue")
  },
  {
    name: "admin-faqs",
    path: "/admin/faqs",
    meta: index5cfjLiXShwMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/faqs/index.vue")
  },
  {
    name: "admin-pages-create",
    path: "/admin/pages/create",
    meta: createqQH7K9kcPbMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/create.vue")
  },
  {
    name: "admin-pages-edit-id",
    path: "/admin/pages/edit/:id()",
    meta: _91id_93X6KsYHeO0rMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/edit/[id].vue")
  },
  {
    name: "admin-pages",
    path: "/admin/pages",
    meta: index8Wx9pOgnYVMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/pages/index.vue")
  },
  {
    name: "admin-parameter-items-code-create",
    path: "/admin/parameter/items-:code()/create",
    meta: createSpugr0W0dpMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/create.vue")
  },
  {
    name: "admin-parameter-items-code-edit-id",
    path: "/admin/parameter/items-:code()/edit/:id()",
    meta: _91id_93pR4LC8L6I0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/edit/[id].vue")
  },
  {
    name: "admin-parameter-items-code",
    path: "/admin/parameter/items-:code()",
    meta: indexCSgBQyzYboMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameter/items-[code]/index.vue")
  },
  {
    name: "admin-parameters-create",
    path: "/admin/parameters/create",
    meta: createTrRgVzV2KRMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/create.vue")
  },
  {
    name: "admin-parameters-edit-id",
    path: "/admin/parameters/edit/:id()",
    meta: _91id_93OzQtrsuUGKMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/edit/[id].vue")
  },
  {
    name: "admin-parameters",
    path: "/admin/parameters",
    meta: indexDqn28lsZOUMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/parameters/index.vue")
  },
  {
    name: "admin-registration",
    path: "/admin/registration",
    meta: indexelUgyA08WqMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/registration/index.vue")
  },
  {
    name: "admin-roles-create",
    path: "/admin/roles/create",
    meta: createJQIth1Oq1ZMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/create.vue")
  },
  {
    name: "admin-roles-edit-id",
    path: "/admin/roles/edit/:id()",
    meta: _91id_93C8fJoM0FhPMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/edit/[id].vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: indexPCj5yGuTZuMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/index.vue")
  },
  {
    name: "admin-roles-permissions-id",
    path: "/admin/roles/permissions/:id()",
    meta: indexjuINY5SlVLMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/roles/permissions/[id]/index.vue")
  },
  {
    name: "admin-service-categories-create",
    path: "/admin/service/categories/create",
    meta: createhwlmCnwkWEMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/create.vue")
  },
  {
    name: "admin-service-categories-edit-id",
    path: "/admin/service/categories/edit/:id()",
    meta: _91id_93gt82kBzOydMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/edit/[id].vue")
  },
  {
    name: "admin-service-categories",
    path: "/admin/service/categories",
    meta: indexIQknFwuNtOMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/categories/index.vue")
  },
  {
    name: "admin-service-category-rules-id-create",
    path: "/admin/service/category/rules/:id()/create",
    meta: createeteePaf6iBMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/create.vue")
  },
  {
    name: "admin-service-category-rules-id-edit-rule_id",
    path: "/admin/service/category/rules/:id()/edit/:rule_id()",
    meta: _91rule_id_934flXwgu7pdMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/edit/[rule_id].vue")
  },
  {
    name: "admin-service-category-rules-id",
    path: "/admin/service/category/rules/:id()",
    meta: indexmI0ZtJo9BpMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/service/category/rules/[id]/index.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: settingsqrbjAN3RcwMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/admin/settings.vue")
  },
  {
    name: "balance-packages",
    path: "/balance/packages",
    meta: indexHrKchfEHuEMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/balance/packages/index.vue")
  },
  {
    name: "contract-gizlilik-ve-cerez-politikasi",
    path: "/contract/gizlilik-ve-cerez-politikasi",
    meta: indexM9aLch4MeTMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/contract/gizlilik-ve-cerez-politikasi/index.vue")
  },
  {
    name: "contract-kvkk",
    path: "/contract/kvkk",
    meta: indexVDEdQTjFFrMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/contract/kvkk/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexdiqTcZDXw0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/dashboard/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    meta: indexattmg6WcVbMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/faq/index.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    meta: forgotHAbfhbdBC1Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/forgot.vue")
  },
  {
    name: "forgottt",
    path: "/forgottt",
    meta: indexor8mKMqNJJMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/forgottt/index.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: indexgfM2baTbPmMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/home/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexI7vlsopydNMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/index.vue")
  },
  {
    name: "information-perfect-price-logs",
    path: "/information/perfect-price-logs",
    meta: indexHige0MBozYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/information/perfect-price-logs/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginaSqImQc0I0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/login.vue")
  },
  {
    name: "me-missions-action-approved",
    path: "/me/missions/action/approved",
    meta: indexshRtoMMbfyMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/approved/index.vue")
  },
  {
    name: "me-missions-action-rejected",
    path: "/me/missions/action/rejected",
    meta: indexbr41LRa09HMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/rejected/index.vue")
  },
  {
    name: "me-missions-action-waiting",
    path: "/me/missions/action/waiting",
    meta: indexw2CYodKJpVMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/action/waiting/index.vue")
  },
  {
    name: "me-missions",
    path: "/me/missions",
    meta: indexmHDBx9kHoYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/index.vue")
  },
  {
    name: "me-missions-proof-pending-approval-id",
    path: "/me/missions/proof-pending-approval/:id()",
    meta: indexF9zCjULphJMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/[id]/index.vue")
  },
  {
    name: "me-missions-proof-pending-approval",
    path: "/me/missions/proof-pending-approval",
    meta: indexgEvOs0xAA2Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proof-pending-approval/index.vue")
  },
  {
    name: "me-missions-proofs-declined-id",
    path: "/me/missions/proofs/declined/:id()",
    meta: _91id_93uqKjWchIBLMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proofs/declined/[id].vue")
  },
  {
    name: "me-missions-proofs",
    path: "/me/missions/proofs",
    meta: indexMvQql2S8eoMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/proofs/index.vue")
  },
  {
    name: "me-missions-re-upload-proof-id",
    path: "/me/missions/re-upload-proof/:id()",
    meta: _91id_93tXEFJX3XFGMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/re-upload-proof/[id].vue")
  },
  {
    name: "me-missions-rejected-proofs-id",
    path: "/me/missions/rejected-proofs/:id()",
    meta: indexZxtjuZWAb3Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/[id]/index.vue")
  },
  {
    name: "me-missions-rejected-proofs",
    path: "/me/missions/rejected-proofs",
    meta: indexcYLhtiS9yIMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/me/missions/rejected-proofs/index.vue")
  },
  {
    name: "mission-id",
    path: "/mission/:id()",
    meta: _91id_937Saj6uAaCHMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mission/[id].vue")
  },
  {
    name: "missions-id",
    path: "/missions/:id()",
    meta: indexQmdmoBYvARMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/[id]/index.vue")
  },
  {
    name: "missions-create-backup",
    path: "/missions/create-backup",
    meta: create_45backupdWRtbW5ZBvMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/create-backup.vue")
  },
  {
    name: "missions-create",
    path: "/missions/create",
    meta: create5OG2ciL0upMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/create.vue")
  },
  {
    name: "missions-detail-id",
    path: "/missions/detail/:id()",
    meta: _91id_93cs657lNmJzMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/detail/[id].vue")
  },
  {
    name: "missions-edit-id",
    path: "/missions/edit/:id()",
    meta: _91id_93Iq4yVrb7bhMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/edit/[id].vue")
  },
  {
    name: "missions",
    path: "/missions",
    meta: indexBaNxbyiOy4Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/index.vue")
  },
  {
    name: "missions-past-missions",
    path: "/missions/past-missions",
    meta: index8hnkTsgWO2Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/past-missions/index.vue")
  },
  {
    name: "missions-pending-approval",
    path: "/missions/pending-approval",
    meta: indexCk5gjxHlbIMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/pending-approval/index.vue")
  },
  {
    name: "missions-proof-decline-request-id",
    path: "/missions/proof-decline-request/:id()",
    meta: indexNFgjgXtR5PMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-decline-request/[id]/index.vue")
  },
  {
    name: "missions-proof-decline-request",
    path: "/missions/proof-decline-request",
    meta: indexwHZVYz6vNkMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-decline-request/index.vue")
  },
  {
    name: "missions-proof-pending-approval-id",
    path: "/missions/proof-pending-approval/:id()",
    meta: indexKlmD6e7skMMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/[id]/index.vue")
  },
  {
    name: "missions-proof-pending-approval",
    path: "/missions/proof-pending-approval",
    meta: indexOWelM4hS78Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/index.vue")
  },
  {
    name: "missions-proof-pending-approval-me-id",
    path: "/missions/proof-pending-approval/me/:id()",
    meta: indexRqv4RncvwAMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/[id]/index.vue")
  },
  {
    name: "missions-proof-pending-approval-me",
    path: "/missions/proof-pending-approval/me",
    meta: indexEz1xb2fZzvMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-approval/me/index.vue")
  },
  {
    name: "missions-proof-pending-users-id",
    path: "/missions/proof-pending-users/:id()",
    meta: indexoA5KfCIBLaMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-users/[id]/index.vue")
  },
  {
    name: "missions-proof-pending-users",
    path: "/missions/proof-pending-users",
    meta: indexEI1RDS07qjMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proof-pending-users/index.vue")
  },
  {
    name: "missions-proofs-id",
    path: "/missions/proofs/:id()",
    meta: indexnozUuVG4ZcMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proofs/[id]/index.vue")
  },
  {
    name: "missions-proofs-me-id",
    path: "/missions/proofs/me/:id()",
    meta: indexDhC7VRkEUUMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/proofs/me/[id]/index.vue")
  },
  {
    name: "missions-show-id",
    path: "/missions/show/:id()",
    meta: _91id_93Ew2M6jLnlaMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/show/[id].vue")
  },
  {
    name: "missions-tracking-me-id",
    path: "/missions/tracking/me/:id()",
    meta: indexyoW3Mfv3LmMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/tracking/me/[id]/index.vue")
  },
  {
    name: "missions-user-with-proofs-id",
    path: "/missions/user-with-proofs/:id()",
    meta: indexccuvK1OlG8Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/user-with-proofs/[id]/index.vue")
  },
  {
    name: "missions-user-with-proofs",
    path: "/missions/user-with-proofs",
    meta: indexK0ihlyogmZMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/missions/user-with-proofs/index.vue")
  },
  {
    name: "mobile-announcements-create",
    path: "/mobile/announcements/create",
    meta: createTeMXhHSek0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/create.vue")
  },
  {
    name: "mobile-announcements-edit-id",
    path: "/mobile/announcements/edit/:id()",
    meta: _91id_93YvsTLrWilrMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/edit/[id].vue")
  },
  {
    name: "mobile-announcements",
    path: "/mobile/announcements",
    meta: index7zFw2SERevMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/announcements/index.vue")
  },
  {
    name: "mobile-pages-create",
    path: "/mobile/pages/create",
    meta: createQzNq6LNfZIMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/create.vue")
  },
  {
    name: "mobile-pages-edit-id",
    path: "/mobile/pages/edit/:id()",
    meta: _91id_93yU0dgw8KQtMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/edit/[id].vue")
  },
  {
    name: "mobile-pages",
    path: "/mobile/pages",
    meta: indexYIjDkpf0fuMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/mobile/pages/index.vue")
  },
  {
    name: "new-mission",
    path: "/new-mission",
    meta: new_45mission6VNvpxQhOuMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/new-mission.vue")
  },
  {
    name: "new-subscription",
    path: "/new-subscription",
    meta: new_45subscriptionWDfmyGH7viMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/new-subscription.vue")
  },
  {
    name: "order-tracking",
    path: "/order-tracking",
    meta: indexPIIremzzQ0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/order-tracking/index.vue")
  },
  {
    name: "packages-create",
    path: "/packages/create",
    meta: createMcPQOyKj6HMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/packages/create.vue")
  },
  {
    name: "packages-edit-id",
    path: "/packages/edit/:id()",
    meta: _91id_93j5RBwZY04dMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/packages/edit/[id].vue")
  },
  {
    name: "packages",
    path: "/packages",
    meta: indexl6mG9S3TjYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/packages/index.vue")
  },
  {
    name: "pages-id",
    path: "/pages/:id()",
    meta: indexnoKX34oFqyMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/pages/[id]/index.vue")
  },
  {
    name: "payment-accounts-create",
    path: "/payment/accounts/create",
    meta: createwx2BYc1g1EMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/create.vue")
  },
  {
    name: "payment-accounts-edit-id",
    path: "/payment/accounts/edit/:id()",
    meta: _91id_93uz6wrrk5zMMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/edit/[id].vue")
  },
  {
    name: "payment-accounts",
    path: "/payment/accounts",
    meta: indexc2qREoliYYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/index.vue")
  },
  {
    name: "payment-accounts-me-create",
    path: "/payment/accounts/me/create",
    meta: createyuNuKX2ugAMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/create.vue")
  },
  {
    name: "payment-accounts-me-edit-id",
    path: "/payment/accounts/me/edit/:id()",
    meta: _91id_93DOclsikipaMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/edit/[id].vue")
  },
  {
    name: "payment-accounts-me",
    path: "/payment/accounts/me",
    meta: index5tOaED1wjwMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/accounts/me/index.vue")
  },
  {
    name: "payment-plans-create",
    path: "/payment/plans/create",
    meta: createVkvfjWajcVMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/create.vue")
  },
  {
    name: "payment-plans-edit-id",
    path: "/payment/plans/edit/:id()",
    meta: _91id_93xTQs46gZr1Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/edit/[id].vue")
  },
  {
    name: "payment-plans",
    path: "/payment/plans",
    meta: indexogt2rDT6w8Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/index.vue")
  },
  {
    name: "payment-plans-me",
    path: "/payment/plans/me",
    meta: indexcACZGyjKN5Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/payment/plans/me/index.vue")
  },
  {
    name: "perfect-service-edit-id",
    path: "/perfect-service/edit/:id()",
    meta: _91id_93wi0dBVm8uUMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/edit/[id].vue")
  },
  {
    name: "perfect-service",
    path: "/perfect-service",
    meta: indexEubYmAXaprMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/index.vue")
  },
  {
    name: "perfect-service-show-id",
    path: "/perfect-service/show/:id()",
    meta: _91id_93B2BSYgYUm3Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/perfect-service/show/[id].vue")
  },
  {
    name: "permission-denied",
    path: "/permission-denied",
    meta: permission_45denied9pRl42EeAOMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/permission-denied.vue")
  },
  {
    name: "price-list",
    path: "/price/list",
    meta: indexv1R7MCbCSAMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/price/list/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: index7m7Ze5cbbCMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/profile/index.vue")
  },
  {
    name: "reference-system",
    path: "/reference-system",
    meta: indexZz1bUXe7uXMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reference-system/index.vue")
  },
  {
    name: "references-create",
    path: "/references/create",
    meta: createiYvoekFi4oMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/references/create.vue")
  },
  {
    name: "references-edit-id",
    path: "/references/edit/:id()",
    meta: _91id_93dY1QiI2UPpMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/references/edit/[id].vue")
  },
  {
    name: "references",
    path: "/references",
    meta: indexVSGKq8xQFoMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/references/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerK5Oi3BOypRMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/register.vue")
  },
  {
    name: "reward-settings-categories-create",
    path: "/reward-settings/categories/create",
    meta: createGa7ZQwrOcMMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/create.vue")
  },
  {
    name: "reward-settings-categories-edit-id",
    path: "/reward-settings/categories/edit/:id()",
    meta: _91id_93XoXf4YboRrMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/edit/[id].vue")
  },
  {
    name: "reward-settings-categories",
    path: "/reward-settings/categories",
    meta: indexf6tQvFZu4XMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/categories/index.vue")
  },
  {
    name: "reward-settings-items-create",
    path: "/reward-settings/items/create",
    meta: createPqgIwTGHIUMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/create.vue")
  },
  {
    name: "reward-settings-items-edit-id",
    path: "/reward-settings/items/edit/:id()",
    meta: _91id_93DjIZv2MsprMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/edit/[id].vue")
  },
  {
    name: "reward-settings-items",
    path: "/reward-settings/items",
    meta: indexa1zNuHh3x2Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward-settings/items/index.vue")
  },
  {
    name: "reward-requests-create",
    path: "/reward/requests/create",
    meta: create6RHJUrRrhYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/create.vue")
  },
  {
    name: "reward-requests",
    path: "/reward/requests",
    meta: indexldHp69mVyGMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/index.vue")
  },
  {
    name: "reward-requests-me-create-id",
    path: "/reward/requests/me/create/:id()",
    meta: indexEkNXvFNpmDMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/create/[id]/index.vue")
  },
  {
    name: "reward-requests-me-create",
    path: "/reward/requests/me/create",
    meta: indexrMkEn0Pk9SMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/create/index.vue")
  },
  {
    name: "reward-requests-me",
    path: "/reward/requests/me",
    meta: indexqBDRCxGeQlMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/reward/requests/me/index.vue")
  },
  {
    name: "service-packages-create",
    path: "/service-packages/create",
    meta: createLthK0gmxITMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/create.vue")
  },
  {
    name: "service-packages-edit-id",
    path: "/service-packages/edit/:id()",
    meta: _91id_93a0WBjAPuGMMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/edit/[id].vue")
  },
  {
    name: "service-packages",
    path: "/service-packages",
    meta: indexfyRUldC79oMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/service-packages/index.vue")
  },
  {
    name: "services-create",
    path: "/services/create",
    meta: create4C6lVQpACQMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/services/create.vue")
  },
  {
    name: "services-edit-id",
    path: "/services/edit/:id()",
    meta: _91id_93CstVHHPQ0dMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/services/edit/[id].vue")
  },
  {
    name: "services",
    path: "/services",
    meta: index6rbdrdmbG3Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/services/index.vue")
  },
  {
    name: "services-steps-id",
    path: "/services/steps/:id()",
    meta: _91id_93y9vsEf7S5bMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/services/steps/[id].vue")
  },
  {
    name: "social-accounts-banned-create",
    path: "/social/accounts/banned/create",
    meta: createphCY2Zdx29Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/create.vue")
  },
  {
    name: "social-accounts-banned-edit-id",
    path: "/social/accounts/banned/edit/:id()",
    meta: _91id_933NltDVEbjPMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/edit/[id].vue")
  },
  {
    name: "social-accounts-banned",
    path: "/social/accounts/banned",
    meta: indexMECCssBCEMMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/banned/index.vue")
  },
  {
    name: "social-accounts",
    path: "/social/accounts",
    meta: indexeGIuJYbvdnMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/index.vue")
  },
  {
    name: "social-accounts-proof",
    path: "/social/accounts/proof",
    meta: indexGmUcmgnS4EMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/social/accounts/proof/index.vue")
  },
  {
    name: "store-orders-create",
    path: "/store/orders/create",
    meta: createOTvB4rYG1TMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/create.vue")
  },
  {
    name: "store-orders",
    path: "/store/orders",
    meta: indexOZFfF7yVL0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/index.vue")
  },
  {
    name: "store-orders-me-create-store_category_id-store_group_id",
    path: "/store/orders/me/create/:store_category_id()/:store_group_id()",
    meta: indexMeXvUoLO3CMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_group_id]/index.vue")
  },
  {
    name: "store-orders-me-create-store_category_id-store_service_id",
    path: "/store/orders/me/create/:store_category_id()/:store_service_id()",
    meta: indexkgTaMIBl7aMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/[store_service_id]/index.vue")
  },
  {
    name: "store-orders-me-create-store_category_id",
    path: "/store/orders/me/create/:store_category_id()",
    meta: indextd03po33ruMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/[store_category_id]/index.vue")
  },
  {
    name: "store-orders-me-create",
    path: "/store/orders/me/create",
    meta: indexPE8MiODQefMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/create/index.vue")
  },
  {
    name: "store-orders-me",
    path: "/store/orders/me",
    meta: index6YTX7SVHnSMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/orders/me/index.vue")
  },
  {
    name: "store-settings-categories-create",
    path: "/store/settings/categories/create",
    meta: createrUEYYPEmTwMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/create.vue")
  },
  {
    name: "store-settings-categories-edit-id",
    path: "/store/settings/categories/edit/:id()",
    meta: _91id_93TR1J6Rkp87Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/edit/[id].vue")
  },
  {
    name: "store-settings-categories",
    path: "/store/settings/categories",
    meta: indexmlixZzyS5RMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/categories/index.vue")
  },
  {
    name: "store-settings-groups-create",
    path: "/store/settings/groups/create",
    meta: createWjTi6UltsZMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/create.vue")
  },
  {
    name: "store-settings-groups-edit-id",
    path: "/store/settings/groups/edit/:id()",
    meta: _91id_934ycKlXqqqfMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/edit/[id].vue")
  },
  {
    name: "store-settings-groups",
    path: "/store/settings/groups",
    meta: indexiw5wOBg6RAMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/groups/index.vue")
  },
  {
    name: "store-settings-packages-package_id-attributes-create",
    path: "/store/settings/packages/:package_id()/attributes/create",
    meta: createUA0xR0MrOXMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/create.vue")
  },
  {
    name: "store-settings-packages-package_id-attributes-edit-id",
    path: "/store/settings/packages/:package_id()/attributes/edit/:id()",
    meta: _91id_93ODVQC8LrihMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/edit/[id].vue")
  },
  {
    name: "store-settings-packages-package_id-attributes",
    path: "/store/settings/packages/:package_id()/attributes",
    meta: index7B1O6GfR1WMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/[package_id]/attributes/index.vue")
  },
  {
    name: "store-settings-packages-create",
    path: "/store/settings/packages/create",
    meta: createsDPBhHmn4PMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/create.vue")
  },
  {
    name: "store-settings-packages-edit-id",
    path: "/store/settings/packages/edit/:id()",
    meta: _91id_93Yv23fHvsCRMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/edit/[id].vue")
  },
  {
    name: "store-settings-packages",
    path: "/store/settings/packages",
    meta: indexaK1jlEjIo0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/packages/index.vue")
  },
  {
    name: "store-settings-services-create",
    path: "/store/settings/services/create",
    meta: createBxuTq8vynLMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/create.vue")
  },
  {
    name: "store-settings-services-edit-id",
    path: "/store/settings/services/edit/:id()",
    meta: _91id_93bnA5nuiivYMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/edit/[id].vue")
  },
  {
    name: "store-settings-services",
    path: "/store/settings/services",
    meta: indexAogWeW3MgmMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/store/settings/services/index.vue")
  },
  {
    name: "subscription-packages",
    path: "/subscription-packages",
    meta: indexxdRz4NwExxMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/subscription-packages/index.vue")
  },
  {
    name: "subscriptions",
    path: "/subscriptions",
    meta: indexgAssRTdMdSMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/subscriptions/index.vue")
  },
  {
    name: "subscriptions-pending-approval",
    path: "/subscriptions/pending-approval",
    meta: indexPH96J7Rob5Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/subscriptions/pending-approval/index.vue")
  },
  {
    name: "tickets-detail-for-user-id",
    path: "/tickets/detail-for-user/:id()",
    meta: _91id_93n24lnNVZhIMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/detail-for-user/[id].vue")
  },
  {
    name: "tickets-detail-id",
    path: "/tickets/detail/:id()",
    meta: _91id_93AG1L7Gzm4LMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/detail/[id].vue")
  },
  {
    name: "tickets-edit-id",
    path: "/tickets/edit/:id()",
    meta: _91id_93VrblG9km2fMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/edit/[id].vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    meta: indexd9LsEmgz0xMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/index.vue")
  },
  {
    name: "tickets-me-id",
    path: "/tickets/me/:id()",
    meta: indexBUegm63sz6Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/[id]/index.vue")
  },
  {
    name: "tickets-me-create",
    path: "/tickets/me/create",
    meta: createtnmLsqcDk3Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/create.vue")
  },
  {
    name: "tickets-me",
    path: "/tickets/me",
    meta: index9y3XYmHo4JMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/tickets/me/index.vue")
  },
  {
    name: "two-factor",
    path: "/two-factor",
    meta: two_45factorN6JeXy68ivMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/two-factor.vue")
  },
  {
    name: "users-banned",
    path: "/users/banned",
    meta: indexQWyDnpnLduMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/users/banned/index.vue")
  },
  {
    name: "users-create",
    path: "/users/create",
    meta: createJDvDfxbrQyMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/users/create.vue")
  },
  {
    name: "users-edit-id",
    path: "/users/edit/:id()",
    meta: _91id_93fSN3NcwUV0Meta || {},
    component: () => import("/var/www/frontend_build/.app/pages/users/edit/[id].vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexn1RB3cGGSkMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/users/index.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verifyKApjB3aXEiMeta || {},
    component: () => import("/var/www/frontend_build/.app/pages/verify.vue")
  }
]